import { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePastPlans } from '../api/planner';
import { Pager } from './review/shared';
import { weekLabel } from '../weeks';

/** How many weeks the server puts on a page. */
const PAGE_SIZE = 50;

/** The weeks already cooked.
 *
 * Only the plan that was accepted appears. A decided week also holds up to
 * four archived alternates -- the other shops that were considered, some of
 * them there only to record why they were passed over -- and listing those
 * would show the same week five times over with dinners nobody ate.
 */
export default function PlanHistory() {
  const [page, setPage] = useState(1);
  const { data, isLoading } = usePastPlans(page);
  const weeks = data?.results ?? [];

  if (isLoading) return <p className="center-note">Loading past weeks…</p>;

  return (
    <section>
      <h1>Past weeks</h1>

      {weeks.length === 0 ? (
        <p className="muted">
          Nothing here yet.
        </p>
      ) : (
        <>
          <ul className="week-list">
            {weeks.map((week) => (
              <li key={week.id} className="card week-card">
                <Link to={`/history/${week.week_start}`} className="week-card__link">
                  <span className="week-card__week">
                    Week of {weekLabel(week.week_start)}
                  </span>
                  <span className="muted small">
                    {week.store} · {week.entries.length}{' '}
                    {week.entries.length === 1 ? 'dinner' : 'dinners'}
                  </span>
                </Link>
              </li>
            ))}
          </ul>

          <Pager
            page={page}
            total={data?.count ?? 0}
            pageSize={PAGE_SIZE}
            hasNext={Boolean(data?.next)}
            onPage={setPage}
            noun="weeks"
          />
        </>
      )}
    </section>
  );
}
